//
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import {dispatchEvent} from 'fg-frontend/src/lib/dom';

import classNames from 'fg-frontend/src/lib/classNames';

const fragments = {
  OVERLAY: '[data-fragment="EshopHeader.overlay"]',
  MENU: '[data-fragment="EshopHeader.menu"]',
  MENU_RWD_TOGGLE: '[data-fragment="EshopHeader.menuRwdToggle"]',
  MENU_ITEM: '[data-fragment="EshopHeader.menuItem"]',
  MENU_ITEM_LINK: '[data-fragment="EshopHeader.menuItemLink"]',
  MENU_ITEM_BACK: '[data-fragment="EshopHeader.menuItemBack"]',
  HEADER_MENU: '[data-fragment="EshopHeader.headerMenu"]',
  HEADER_FULLTEXT: '[data-fragment="EshopHeader.headerFulltext"]',
  FULLTEXT_RWD_TOGGLE: '[data-fragment="EshopHeader.fulltextRwdToggle"]',
};

export default class EshopHeader extends WebComponent {
  constructor(props) {
    super(props);
    this.handleToggleMenu = this.handleToggleMenu.bind(this);
    this.handleToggleFulltext = this.handleToggleFulltext.bind(this);
    this.handleSubmenuBackBtn = this.handleSubmenuBackBtn.bind(this);
    this.handleToggleSubmenu = this.handleToggleSubmenu.bind(this);
    this.handleToggleMegamenuEnter = this.handleToggleMegamenuEnter.bind(this);
    this.handleToggleMegamenuLeave = this.handleToggleMegamenuLeave.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);

    this.overlayActive = false;
    this.fulltextActive = false;
    this.megamenuActive = false;
    this.waitingForMegamenuClose = false;
    this.megamenuActiveItem = '';
    this.megamenuCurrentItem = '';
    this.waitingForMegamenuItem = '';
    this.rwdMenuActive = false;
    this.timer = null;

    this.state = {
      overlayActive: false,
      bodyOverlayActiveClass: false,
      fulltextActive: false,
      menuRwdToggleActive: false,
      rwdMenuActive: false,
      megamenuActive: false,
    };
  }
  didMount() {
    // common elements
    this.body = document.querySelector('body');
    this.overlay = document.querySelector(fragments.OVERLAY);

    this.input = document.querySelector('#query')

    // menu elements
    this.menu = this.element.querySelector(fragments.MENU);
    this.menuRwdToggle = this.element.querySelector(fragments.MENU_RWD_TOGGLE);
    this.menuItems = this.element.querySelectorAll(fragments.MENU_ITEM);
    this.menuItemsLink = this.element.querySelectorAll(fragments.MENU_ITEM_LINK);
    this.menuItemsBack = this.element.querySelectorAll(fragments.MENU_ITEM_BACK);

    // layout elements
    this.headerMenu = this.element.querySelector(fragments.HEADER_MENU);
    this.headerFulltext = this.element.querySelector(fragments.HEADER_FULLTEXT);

    // fulltext elements
    this.fulltextRwdToggle = this.element.querySelector(fragments.FULLTEXT_RWD_TOGGLE);

    // bind events
    this.fulltextRwdToggle.addEventListener('click', this.handleToggleFulltext);
    this.menuRwdToggle.addEventListener('click', this.handleToggleMenu);
    this.menuItemsBack.forEach((btn) => {
      btn.addEventListener('click', this.handleSubmenuBackBtn);
    });
    this.menuItemsLink.forEach((btn) => {
      btn.addEventListener('click', this.handleToggleSubmenu);
    });
    this.menuItems.forEach((item) => {
      item.addEventListener('mouseenter', this.handleToggleMegamenuEnter);
      item.addEventListener('mouseleave', this.handleToggleMegamenuLeave);
    });
  }

  willUnMount() {
    this.fulltextRwdToggle.removeEventListener('click', this.handleToggleFulltext);
    this.menuRwdToggle.removeEventListener('click', this.handleToggleMenu);
    this.menuItemsBack.forEach((btn) => {
      btn.removeEventListener('click', this.handleSubmenuBackBtn);
    });
    this.menuItemsLink.forEach((btn) => {
      btn.removeEventListener('click', this.handleToggleSubmenu);
    });
    this.menuItems.forEach((item) => {
      item.removeEventListener('mouseenter', this.handleToggleMegamenuEnter);
      item.removeEventListener('mouseleave', this.handleToggleMegamenuLeave);
    });
  }

  // enter megamenu
  handleToggleMegamenuEnter(e) {
    const {
      megamenuBreakpoint,
      hoverClass
    } = this.props;

    if (window.innerWidth >= megamenuBreakpoint) {

      this.setState({
        bodyOverlayActiveClass: true,
        megamenuActive: true,
        overlayActive: true,
        fulltextActive: false,
      });

      this.megamenuCurrentItem = e.target;

      if (this.megamenuActiveItem == '') {
        this.megamenuActiveItem = e.target;
        clearTimeout(this.timer);
        this.waitingForMegamenuClose = false;
        this.megamenuActiveItem.classList.add(hoverClass);
      }
      else{
        if (e.target == this.megamenuActiveItem) {
          this.waitingForMegamenuClose = false;
          clearTimeout(this.timer);
        }
        else {
          this.waitingForMegamenuItem = e.target;
          this.waitingForMegamenuClose = true;
        }
      }
    }

    if(this.state.fulltextActive) {
      console.log('Fulltex otevreny');
      this.setState({
        fulltextActive: false,
        bodyOverlayActiveClass: true,
        overlayActive: true,
      });
    }
    if(this.input) this.input.blur();
  }

  // leave megamenu
  handleToggleMegamenuLeave(e) {
    const {
      hoverClass,
      megamenuTimerInterval,
      megamenuBreakpoint,
    } = this.props;
    if (window.innerWidth >= megamenuBreakpoint) {
      this.setState({
        bodyOverlayActiveClass: false,
        megamenuActive: false,
        overlayActive: false,
      });
      clearTimeout(this.timer);
      this.megamenuCurrentItem = '';
      this.timer = window.setTimeout(()=>{
        this.megamenuActive = false;
        if (this.megamenuActiveItem != '') {
          this.megamenuActiveItem.classList.remove(hoverClass);
          this.megamenuActiveItem = '';
        }
        if (this.waitingForMegamenuClose) {
          this.waitingForMegamenuClose = false;
          if (this.megamenuCurrentItem != '') {
            dispatchEvent(this.waitingForMegamenuItem, 'mouseenter');
          }
        }
      }, megamenuTimerInterval);
    }
  }

  // toggle rwd submenu
  handleToggleSubmenu(e) {
    const {
      activeClass,
      megamenuBreakpoint,
    } = this.props;

    if (window.innerWidth < megamenuBreakpoint) {
      const trigger = e.target;
      const subMenu = trigger.nextElementSibling;

      if (subMenu) {
        e.preventDefault();

        trigger.classList.toggle(activeClass);
        subMenu.classList.toggle(activeClass);
        this.menu.style.minHeight = subMenu.offsetHeight + 'px';
      }
    }
  }

  // return rwd submenu
  handleSubmenuBackBtn(e) {
    const {
      activeClass,
    } = this.props;

    const parentPopup = e.target.parentElement.closest('.submenu');

    if (parentPopup) {
      parentPopup.classList.toggle(activeClass);
      this.menu.style.minHeight = '';
    }
  }

  // toggle rwd menu
  handleToggleMenu() {
    const self = this;
    // state toggle
    this.setState({
      bodyOverlayActiveClass: !this.state.bodyOverlayActiveClass,
      overlayActive: !this.state.overlayActive,
      menuRwdToggle: !this.state.menuRwdToggle,
      rwdMenuActive: !this.state.rwdMenuActive,
    });

    // if menu opened handle its states
    if (this.state.fulltextActive) {
      this.setState({
        bodyOverlayActiveClass: true,
        overlayActive: true,
        fulltextActive: false,
      });
    }
    if(self.input) self.input.blur()
    this.handleClickOutside();
  }

  // toggle rwd fulltext
  handleToggleFulltext() {
    const self = this;
    // state toggle
    this.setState({
      bodyOverlayActiveClass: !this.state.bodyOverlayActiveClass,
      overlayActive: !this.state.overlayActive,
      fulltextActive: !this.state.fulltextActive,
    });

    // if menu opened handle its states
    if (this.state.rwdMenuActive) {
      this.setState({
        menuRwdToggle: false,
        rwdMenuActive: false,
        bodyOverlayActiveClass: true,
        overlayActive: true,
      });
    }
    // focus in input
    if(self.input) self.input.focus();

    this.handleClickOutside();
  }

  handleClickOutside(e){
    const self = this;
    // close fulltext on aside click
    window.addEventListener('click', function(e){
      // console.log(e.target);
      if(e.target.classList.contains('layout')) {
        self.setState({
          bodyOverlayActiveClass: false,
          overlayActive: false,
          fulltextActive: false,
          menuRwdToggle: false,
          rwdMenuActive: false,
        });


        if(self.input) self.input.blur();
        window.removeEventListener('click', this);
      }
    })
  }

  update() {
    const self = this;
    const {
      bodyOverlayActiveClass,
      overlayActive,
      fulltextActive,
      menuRwdToggleActive,
      rwdMenuActive,
      megamenuActive,
    } = this.state;

    // Generics
    classNames(this.body, { 'overlay--active': bodyOverlayActiveClass });
    classNames(this.body, { 'megamenu--active' : megamenuActive });
    classNames(this.overlay, { active: overlayActive });
    // Fulltext toggle
    classNames(this.headerFulltext, { active: fulltextActive });
    classNames(this.fulltextRwdToggle, { active: fulltextActive });
    classNames(this.menuRwdToggle, { boac: rwdMenuActive });
    // RWD menu states
    classNames(this.menuRwdToggle, { active: menuRwdToggleActive });
    classNames(this.menuRwdToggle, { active: rwdMenuActive });
    classNames(this.headerMenu, { active: rwdMenuActive });
  }
}

EshopHeader.defaultProps = {
  activeClass: 'active',
  hoverClass: 'hover',
  megamenuTimerInterval: 450,
  megamenuBreakpoint: 992,
  bodyMegamenuActiveClass: 'megamenu--active',
  bodyOverlayActiveClass: 'overlay--active',
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/EshopHeader.js